import { render, staticRenderFns } from "./VoicesList.vue?vue&type=template&id=4d4669a3&"
import script from "./VoicesList.vue?vue&type=script&lang=js&"
export * from "./VoicesList.vue?vue&type=script&lang=js&"
import style0 from "./VoicesList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports